import cn from "classnames";
import SVGEmbed from "@/components/common/SVGEmbed";
import { BackgroundImageAttachment } from "@/constants/media";
import { useBrandPatternURL } from "@/hooks/useBrandPatternURL";
import type { BaseSiteBuilderModule } from "@/types/site-builder";
import s from "./BackgroundPattern.module.scss";

export interface BackgroundPatternProps {
  settings: BaseSiteBuilderModule["style"]["background"]["pattern"];
}

export default function BackgroundPattern(props: BackgroundPatternProps) {
  const {
    settings: { source, attachment },
  } = props;

  const patternURI = useBrandPatternURL(source?.path);

  if (!patternURI) return null;

  const fixed = attachment === BackgroundImageAttachment.Fixed;

  if (fixed && /\/pattern\//i.test(source!.path)) {
    const patternStyle = {
      background: `url(${patternURI}) center / 80px`,
      backgroundAttachment: "fixed",
      opacity: 0.25,
    };

    return <div className="inset-overlay" style={patternStyle} />;
  }

  return (
    <SVGEmbed src={source!.path} className={cn("inset-overlay", s.pattern)} />
  );
}
